// https://developers.google.com/youtube/player_parameters
// https://developers.google.com/youtube/iframe_api_reference

let $youtube;

$(document).ready(function () {
	let $youtubeLinkList = $('a[data-youtube-playlist-id]');

	if (!$youtubeLinkList.length) {
		return;
	}

	$youtubeLinkList.each(function (index) {
		let $this = $(this);
		$this.parent().attr('index', index).attr('data-youtube-playlist-id', $this.attr('data-youtube-playlist-id'));
	});

	$youtubeLinkList.click(function () {
		let $this = $(this);
		$youtube = $this.parent();

		$this.hide();

		let playlistId = $youtube.attr('data-youtube-playlist-id');
		let index      = $youtube.attr('index');

		$('<div id="youtubeplayer-' + playlistId + '-' + index + '"></div>').appendTo($youtube);

		if (typeof YT === 'object') {
			createYoutubePlayerToWrapper();
		}
		else {
			$('body').append('<script src="https://www.youtube.com/iframe_api" type="text/javascript"></script>');
		}

		return false;
	});
});


function createYoutubePlayerToWrapper() {
	if ($youtube === undefined) {
		return;
	}

	let playlistId = $youtube.attr('data-youtube-playlist-id');
	let index      = $youtube.attr('index');

	new YT.Player('youtubeplayer-' + playlistId + '-' + index, {
		playerVars: {
			hl:       $('html').attr('lang'),
			rel:      0,
			listType: 'playlist',
			list:     $youtube.attr('data-youtube-playlist-id')
		},
		events:     {
			'onReady': function (event) {
				event.target.playVideo();
			}
		}
	});

	$youtube = undefined;
}


window.onYouTubeIframeAPIReady = function () {
	createYoutubePlayerToWrapper();
}
